import { useSelector } from 'react-redux'
import { createCurrencyFormatter, CurrencyFormatter } from 'src/localization/currencyFormatter'
import { getLocaleInfo } from 'src/localization/locales'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'

export const useCurrencyFormatter = (): CurrencyFormatter => {
  const locale = useSelector(selectNullSafeLocaleFromState)
  const defaultDisplayCurrency = getLocaleInfo(locale).currency

  return createCurrencyFormatter(locale, defaultDisplayCurrency)
}
